import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DragDropModule, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FilteredLoad } from '../../services/load-management.service';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-load-table',
  templateUrl: './load-table-component.html',
  styleUrls: ['./load-table-component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    DragDropModule,
    MatCheckboxModule,
    FormsModule,
    MatButtonModule
  ],
})
export class LoadTableComponent {
  @Input() loads: FilteredLoad[] = [];  
  @Input() isDraggable: boolean = false;
  @Input() isSelectable: boolean = false;  // New input property for selection
  @Input() showMarkReady: boolean = false;  // Controls visibility of Mark Ready button
  @Output() loadSelected = new EventEmitter<FilteredLoad>();
  @Output() loadsChange = new EventEmitter<FilteredLoad[]>(); // Optional, if parent wants to know about reorder
  @Output() markReadySettlement = new EventEmitter<FilteredLoad>();

  selectAll: boolean = false;  // Bind to Select All checkbox
  indeterminate: boolean = false;  // For the "indeterminate" state of the Select All checkbox

  onLoadClick(load: FilteredLoad) {
    this.loadSelected.emit(load);
  }

  onDrop(event: CdkDragDrop<FilteredLoad[]>) {
    const reordered = [...this.loads];
    moveItemInArray(reordered, event.previousIndex, event.currentIndex);
    this.loads = reordered;
    this.loadsChange.emit(this.loads); // Notify parent
  }

  // Toggle select/deselect all rows
  toggleSelectAll(event: any) {
    this.loads.forEach(load => {
      load.selected = this.selectAll;
    });
    this.onSelectionChange();  // Recalculate selection state
  }

  // Update the Select All checkbox state (to be checked, unchecked, or indeterminate)
  onSelectionChange() {
    const selectedCount = this.loads.filter(load => load.selected).length;
    this.selectAll = selectedCount === this.loads.length;
    this.indeterminate = selectedCount > 0 && selectedCount < this.loads.length;
  }

  // Check if the Select All checkbox should be indeterminate
  isIndeterminate(): boolean {
    const selectedCount = this.loads.filter(load => load.selected).length;
    return selectedCount > 0 && selectedCount < this.loads.length;
  }

  // Optional: Method to get selected items
  getSelectedLoads() {
    return this.loads.filter(load => load.selected);
  }
}
